import { render, staticRenderFns } from "./ChangePasswordStep.vue?vue&type=template&id=01a2f7a7&scoped=true"
import script from "./ChangePasswordStep.vue?vue&type=script&lang=js"
export * from "./ChangePasswordStep.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordStep.vue?vue&type=style&index=0&id=01a2f7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2f7a7",
  null
  
)

export default component.exports